<template>
  <app-modal modal-id="warehouse-modal"
             modal-size="default"
             modal-alignment="top"
             @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">
        {{ selectedUrl ? $t("edit_warehouse_item") : $t("add_warehouse_item") }}
      </h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form ref="form" v-if="dataLoaded" :data-url="selectedUrl ? selectedUrl : `crm/warehouses`">
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("name") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="text"
                  :placeholder="$t('enter_name')"
                  name="name"
                  v-model="formData.name"
                  :error-message="$errorMessage(errors, 'name')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("warehouse_type") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="select"
                  list-value-field="name"
                  :list="warehouseTypeList"
                  :placeholder="$t('choose_an_warehouse_type')"
                  v-model="formData.warehouse_type_id"
                  :error-message="$errorMessage(errors, 'warehouse_type_id')"
              />
            </div>
          </div>
        </div>
        <div class="form-group mb-4">
          <div class="row">
            <div class="mb-0 col-sm-5 d-flex align-items-center">
              <label>{{ $t("price") }}</label>
            </div>
            <div class="col-sm-7">
              <app-input
                  type="number"
                  :placeholder="$t('enter_price')"
                  name="name"
                  v-model="formData.price"
                  :error-message="$errorMessage(errors, 'price')"
              />
            </div>
          </div>
        </div>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button type="button" class="btn btn-primary" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormSubmitMixin} from "@app/Mixins/Global/FormSubmitMixin";
import {mapGetters} from "vuex";

export default {
  name: "WarehouseModal",
  mixins: [FormSubmitMixin],
  data() {
    return {
      isOrganizationModalActive: false,
      addMoreDetails: false,
      dataLoaded: true,
      countryList: [],
      formData: {owner_id: user.id},
      addEditData: {},
      customFieldValue:[],
      warehousesList: [],
    };
  },
  computed: {
    ...mapGetters({

    }),

    warehouseTypeList() {
            return this.$store.getters.WarehouseType
        },

  },
  methods: {
  
   
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
		this.addEditData.name = this.formData.name;
		this.addEditData.owner_id = this.formData.owner_id;
		this.addEditData.price = this.formData.price;
      this.addEditData.warehouse_type_id = this.formData.warehouse_type_id;
      this.save(this.addEditData);
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
   
    },
   
  },
  mounted() {

  },
  created(){
    this.$store.dispatch('WarehouseType');
    
  }
};
</script>
